import React, { Fragment } from "react";

import R from "ramda";

import { themeColor } from "src/styles";

import { Arrow } from "src/icons";

import { Link, Flex, Text } from "src/components/base";

const Breadcrumb = ({
  breadcrumb,
  theme,
  currentPageTitle,
  fontSize = [2, null, 3, null, 4],
  ...props
}) =>
  R.isEmpty(breadcrumb) ? null : (
    <Flex align="center" {...props} wrap="wrap">
      {breadcrumb.map((crumb, index) => (
        <Flex key={crumb.id || crumb.url} align="center" mb={1}>
          {index !== 0 && (
            <Flex mx={1} align="center">
              <Arrow color={themeColor(theme)} size={12} />
            </Flex>
          )}
          <Link
            to={crumb.url}
            color={themeColor(theme)}
            fontSize={fontSize}
            fontWeight="medium"
            textDecoration="none"
            hover={{
              textDecoration: "underline",
            }}
          >
            {crumb.title}
          </Link>
        </Flex>
      ))}
      {Boolean(currentPageTitle) && (
        <Flex align="center" mb={1}>
          <Flex mx={1} align="center">
            <Arrow color={themeColor(theme)} size={12} />
          </Flex>
          <Text
            color={themeColor(theme)}
            fontSize={fontSize}
            fontWeight="medium"
          >
            {currentPageTitle}
          </Text>
        </Flex>
      )}
    </Flex>
  );

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/components/Breadcrumb.js